import { Box } from '@mui/material'

import { TextTag } from 'src/components/text-tag'
import { ILocationBaseWithId } from 'src/types/locations.type'

interface IProps {
  locations: ILocationBaseWithId[]
}

export const LocationList = ({ locations }: IProps) => {
  return (
    <Box sx={{ display: 'flex', rowGap: '3px', columnGap: '3px', flexWrap: 'wrap' }}>
      {locations.map((item) => (
        <TextTag key={item.id} label={item.location_name} />
      ))}
    </Box>
  )
}
